import styled from 'styled-components/macro';
import Typography from '../Typography';

export const StyledTrimmedCardContainer = styled.div`
  display: grid;
  grid-template-columns: 174px 126px;
  gap: 20px;
`;

export const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  font-family: ${({ theme }) => theme.fonts.primary};

  & > div, & > a {
    margin-top: 12px;
  }
`;

export const ForSaleContainer = styled.div`
  height: 15px;
  width: 73px;
  margin-top: 17px;
  background-color: ${({ theme }) => theme.colors.yellow};

  text-align: center;
  font-size: 11px;
  line-height: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

interface SideTextProps {
  size?: number
  textColor?: string
}

export const SideText = styled.p<SideTextProps>`
  letter-spacing: 1px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: #d8d8d8;
`;

export const SideTextCapitalized = styled(SideText)`
  text-transform: capitalize;
`;

export const SideTextLight = styled(SideText)`
  font-size: 16px;
  font-weight: normal;
  text-transform: none;
  color: #666666;
`;

export const SideTextSmall = styled(SideText)<{ textColor?: string }>`
  font-size: 11px;
  line-height: 11px;
  font-weight: normal;
  text-transform: none;
  color: ${({ textColor }) => textColor || '#d8d8d8'};
  margin-top: 5px;
  letter-spacing: -1px;
`;

export const SideTextBlock = styled(SideText)`
  margin-top: 12px;
`;

export const StyledPrice = styled(SideText)`
  margin-top: 4px;
  line-height: 1;
`;

export const StyledTrTitle = styled.div`
  padding-top: 5px;
  line-height: 1.15;
  overflow-wrap: anywhere;
`;

export const StyledTrDescribe = styled.div`
  margin-top: 4px;
  ${Typography}{
    &:not(:last-of-type, :first-of-type){
      margin-top: 9px;
    }
  }
`;

export const StyledNoListings = styled(StyledPrice)`
  margin-top: 12px;
  padding-top: 0;
`;
